import React, { useEffect, useState } from 'react'
import Chart from 'react-google-charts';
import { AgruparConsolidado } from './Agrupar';

export const Consolidado = ({ data, encabezado }) => {
    const [grafica, setGrafica] = useState([]);
    useEffect(() => {
        var array = [encabezado]
        var conceptos = AgruparConsolidado(data);
        conceptos.map(item => {
            array = [...array, [
                item.concepto,
                item.invactual,
                item.invanterior,
            ]]
        })
        setGrafica(array);
    }, [data])
    const colorBars = [
        "rgb(79,123,88)",
        "rgb(155,176,111)"
    ];
    return (
        <div className='grafica'>
            <div >
                <Chart
                    chartType="ColumnChart"
                    loader={<div>Cargando Grafica</div>}
                    width='100%'
                    height='400px'
                    data={grafica
                    }
                    options={{
                        animation: { animation: 0 },
                        colors: colorBars,
                        intervals: { style: 'sticks' }
                    }}
                    legendToggle
                />
            </div>
        </div>
    )
}
